import React, { useEffect, useState } from 'react';
import { GlobalNavigation } from '@paycor/pacl';
import { initCompanySwitcher, setSelectedClient } from 'utils/paycorApp';
import { getFeatureFlag, loadUserInfo } from 'services/employeeService';
import config from 'config';
import { GLOBAL_CLIENT_SWITCHER_FEATURE_FLAG } from 'constants';
import { GlobalClientSwitcher } from 'paycor-react-components-common';
import { useParams } from 'react-router-dom';

const {
	HOST: { GLOBAL_HEADER_URL, APIM_BASE_DOMAIN_URL, HCM_BASE_DOMAIN_URL },
	APIM_SUBSCRIPTION_KEY
} = config;

export default function GlobalNav(props) {
	const { clientId, companyId } = useParams();
	const isLocalNode = process.env.NODE_ENV !== 'production';
	const isQsbEnv = process.env.REACT_APP_ENV === 'qsb';
	const useMockHeader = isLocalNode;
	const needGlobalNav = !isLocalNode || isQsbEnv || props.enable;
	const [isCompanySwitcherEnabled, setCompanySwitcherEnabled] = useState(null);

	const [userAccess, setUserAccess] = useState({
		canSwitchClients: false,
		isPaycor: false,
		limitedClientZeroAccess: false,
		userId: null
	});

	useEffect(() => {
		loadUserInfo().then((userAccess) => {
			setUserAccess(userAccess);
		});
		const loadFeatureFlag = async () => {
			const isEnabled = await getFeatureFlag(GLOBAL_CLIENT_SWITCHER_FEATURE_FLAG, companyId);

			if (isEnabled) {
				initCompanySwitcher();
				await setSelectedClient(parseInt(companyId));
				setCompanySwitcherEnabled(true);
			} else {
				setCompanySwitcherEnabled(false);
			}
			setSelectedClient(clientId);
		};
		if (needGlobalNav && Boolean(companyId)) {
			loadFeatureFlag();
		}
	}, [companyId, clientId, needGlobalNav]);

	const ClientSwitcher = () => {
		const handleClientChange = (client) => {
			setSelectedClient(clientId);
			window.location.href = `${HCM_BASE_DOMAIN_URL}/employeesettings/#/Company/${client.CompanyId}/Client/${client.ClientId}`;
			window.location.reload(true);
		};
		return (
			<>
				{!isCompanySwitcherEnabled && userAccess.isPaycor && clientId && (
					<GlobalClientSwitcher apiDomain={APIM_BASE_DOMAIN_URL} apimSubscriptionKey={APIM_SUBSCRIPTION_KEY} currentClientId={clientId} onClientChange={handleClientChange} />
				)}
			</>
		);
	};

	return (
		<>
			{needGlobalNav && (isCompanySwitcherEnabled !== null || companyId === null) && (
				<GlobalNavigation hcmDomain={GLOBAL_HEADER_URL} apimDomain={APIM_BASE_DOMAIN_URL} apimSubscriptionKey={APIM_SUBSCRIPTION_KEY} useMockHeader={useMockHeader} />
			)}
			<ClientSwitcher />
		</>
	);
}
